module.exports = __webpack_public_path__ + "media/images/icons8-blueprint-3f228911e220d6c5d4cd8f46416cba81.svg";